<div class="generic-tile-container">
  <div class="icon-tile-container" *ngIf="tiles?.length && type !== GenericTileType.TILE_WITH_RADIO">
    <div class="vm-row">
      <div
        class="tile vm-col-sm-12"
        [ngClass]="columnView === 'two-column' || tiles?.length === 1 ? 'two-col-xs' : 'vm-col-md-4'"
        *ngFor="let tile of tiles">
        <div class="vm-tile-container" [ngClass]="tile.iconSize === 'sm' ? 'vm-tile-container__text-small-icons' : ''">
          <div
            *ngIf="tile?.type === 'normal'"
            class="tile-inner"
            vmPreventMultiClicks
            (timeoutClick)="tileSelected(tile)"
            [ngClass]="tile.iconSize === 'sm' ? 'tile-inner__text-small-icons' : ''">
            <ng-template
              [ngTemplateOutlet]="nonRadioTileContent"
              [ngTemplateOutletContext]="{ tile: tile }"></ng-template>
          </div>
          <div
            *ngIf="tile?.type === 'chat'"
            class="tile-inner"
            (click)="openChat($event)"
            [ngClass]="tile.iconSize === 'sm' ? 'tile-inner__text-small-icons' : ''"
            [vmLiveChatV3]="chatbotId">
            <ng-template
              [ngTemplateOutlet]="nonRadioTileContent"
              [ngTemplateOutletContext]="{ tile: tile }"></ng-template>
          </div>
          <div
            *ngIf="tile?.type === 'modal'"
            class="tile-inner"
            (click)="openModal(tile)"
            [ngClass]="tile.iconSize === 'sm' ? 'tile-inner__text-small-icons' : ''">
            <ng-template
              [ngTemplateOutlet]="nonRadioTileContent"
              [ngTemplateOutletContext]="{ tile: tile }"></ng-template>
          </div>
          <vm-modal
            *ngIf="tile.isModalOpen"
            [modalType]="modalType"
            [title]="tile.modalTitle"
            [hideHeader]="false"
            (closeButtonClick)="tile.isModalOpen = false">
            <markdown ngPreserveWhitespaces>
              {{ tile?.modalCopy }}
            </markdown>
          </vm-modal>
        </div>
        <div class="tile-outer-label" *ngIf="tile?.subtitle">
          <markdown ngPreserveWhitespaces>{{ tile?.subtitle }}</markdown>
        </div>
      </div>
    </div>
  </div>
  <div class="tile-outer-text" *ngIf="tilesContainerCopy || tilesContainerHeading">
    <div *ngIf="tilesContainerCopy">
      <markdown ngPreserveWhitespaces>
        {{ tilesContainerCopy }}
      </markdown>
    </div>
    <div *ngIf="tilesContainerHeading">
      <h3 class="tile-outer-heading">{{ tilesContainerHeading }}</h3>
    </div>
  </div>
  <div class="tile-selection-wrapper" *ngIf="type === GenericTileType.TILE_WITH_RADIO">
    <div
      class="tile-selection-card"
      (click)="tileSelected(tile)"
      *ngFor="let tile of tiles; let i = index"
      [ngClass]="{
        'tile-selection-card-selected': tile?.isSelected,
        'tile-unavailable-wrapper': !tile?.isSelectable
      }">
      <div class="Body-Small-Book tile-text">
        {{ tile.title }}
      </div>
      <div class="tile-selection-container">
        <div class="selection-option-indicator" *ngIf="tile?.isSelectable">
          <input
            value="{{ tile }}"
            name="option-{{ tile.index }}"
            type="radio"
            id="option-{{ tile.index }}"
            (ngModel)="(tile)"
            (change)="tileSelected(tile)"
            [checked]="tile?.isSelected" />
        </div>
        <div *ngIf="tile?.isSelected && tile?.isSelectable" class="selected-option-indicator">
          <i class="far fa-check"></i>
        </div>
        <div *ngIf="!tile?.isSelectable" class="Body-X-Small tile-selection-card__unavailable">
          <p class="Body-X-Small-Book">{{ tile.title }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #nonRadioTileContent let-tile="tile">
  <div *ngIf="tile?.iconSrc && !tile?.icon && tile.iconSize === 'lg'" class="tile-img">
    <vm-media [source]="tile?.iconSrc | mediaSrcStrapi: strapiUrl" [altText]=""></vm-media>
  </div>
  <div *ngIf="tile?.iconSrc && !tile?.icon && tile.iconSize === 'sm'" class="tile-icon mb-24">
    <vm-media [source]="tile?.iconSrc | mediaSrcStrapi: strapiUrl" [altText]="tile.alt"></vm-media>
  </div>
  <div *ngIf="tile?.icon">
    <ng-container [ngSwitch]="tile?.iconWeight">
      <i
        *ngSwitchCase="IconWeight.LIGHT"
        class="tile-icon fal fa-fw"
        ngClass="fa-{{ tile?.icon }}"
        [style.color]="tile?.iconColor"></i>
      <i
        *ngSwitchCase="IconWeight.REGULAR"
        class="tile-icon far fa-fw"
        ngClass="fa-{{ tile?.icon }}"
        [style.color]="tile?.iconColor"></i>
      <i
        *ngSwitchCase="IconWeight.SOLID"
        class="tile-icon fas fa-fw"
        ngClass="fa-{{ tile?.icon }}"
        [style.color]="tile?.iconColor"></i>
      <i
        *ngSwitchCase="IconWeight.DUOTONE"
        class="tile-icon fad fa-fw"
        ngClass="fa-{{ tile?.icon }}"
        [style.color]="tile?.iconColor"></i>
      <i
        *ngSwitchCase="IconWeight.BRANDS"
        class="tile-icon fab fa-fw"
        ngClass="fa-{{ tile?.icon }}"
        [style.color]="tile?.iconColor"></i>
      <i *ngSwitchDefault class="tile-icon fa fa-fw" ngClass="fa-{{ tile?.icon }}" [style.color]="tile?.iconColor"></i>
    </ng-container>
  </div>

  <div class="tile-inner-heading" *ngIf="tile?.title">
    <h4>{{ tile?.title }}</h4>
  </div>

  <div class="tile-inner-text" *ngIf="tile?.info">
    <markdown ngPreserveWhitespaces>{{ tile?.info }}</markdown>
  </div>
</ng-template>
